import { useEffect, useState } from "react";
import axios from "axios";
import CategoriesTree from "../components/Categories/CategoriesTree";
import Layout from "../components/Layout";
import Modal from "../components/Modal/Modal";

const Categories = () => {

  useEffect(() => {
    
  }, []);

  return (
    <Layout>
        <CategoriesTree />
    </Layout>
  );
};

export default Categories;
